import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import { currentDateTime, wtGetDateTimeFormat } from 'src/helpers/commons/moment'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { INTERNAL_REQUISITION_STATUS_NAME } from 'src/models/internal-requisition'

const user = wtGetFromLocalStorage('authUser')
const companyName = wtGetFromLocalStorage('company_name', '')

const valueOrDash = (value) => (value === null || value === undefined || value === '' ? '-' : String(value))
const nameOf = (value) => valueOrDash(value?.name)
const formatQuantity = (value) => {
  if (value === null || value === undefined || value === '') return '-'
  const numericValue = Number(value)
  return Number.isFinite(numericValue) ? String(numericValue) : String(value)
}

const formatDate = (value) => (value ? wtGetDateTimeFormat(value).split(' ')[0] : '-')

const Pdf = (rows = [], meta = {}) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    lzNotifyErrorMessageFromResult('No requisition rows available for PDF export.')
    return
  }

  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' })
  const totalPagesExp = '{total_pages_count_string}'
  const pageWidth = doc.internal.pageSize.getWidth()
  const pageHeight = doc.internal.pageSize.getHeight()
  const logo = 'assets/wil-icon.png'

  const header = () => {
    doc.setFontSize(11)
    doc.setTextColor('#3c4b64')
    doc.setFont('Helvetica', 'bold')
    doc.addImage(logo, 'PNG', 5, 4, 25, 25)
    doc.line(32, 6, 32, 25)
    doc.text('WAH', 35, 10)
    doc.text('INDUSTRIES', 35, 15)
    doc.text('LIMITED', 35, 20)
    doc.setFontSize(9)
    doc.text('www.wahindustries.com', 35, 25)
    doc.setFontSize(11)
    doc.text('INTERNAL REQUISITION REPORT', pageWidth - 92, 15)
    doc.setFontSize(9)
    doc.setFont('Helvetica', 'normal')
    doc.setTextColor('#0202f7')
    doc.text(meta.dateLabel || companyName || '', pageWidth - 92, 22)
    doc.line(10, 30, pageWidth - 10, 30)
  }

  const footer = () => {
    const pageNo = doc.internal.getNumberOfPages()
    doc.setFontSize(10)
    doc.setTextColor('black')
    doc.setFont('Helvetica', 'normal')
    doc.text('This report is printed through ERP at ', 92, pageHeight - 15)
    doc.setTextColor('#0202f7')
    doc.setFont('Helvetica', 'bold')
    doc.text(currentDateTime(), 157, pageHeight - 15)
    doc.setTextColor('black')
    doc.setFontSize(9)
    doc.setFont('Helvetica', 'normal')
    doc.line(14, pageHeight - 11, pageWidth - 14, pageHeight - 11)
    doc.text(`Page ${pageNo} of ${totalPagesExp}`, pageWidth - 14, pageHeight - 7, { align: 'right' })
    doc.text('Printed By ', 20, pageHeight - 7)
    doc.setTextColor('blue')
    doc.text(user?.name || '', 37, pageHeight - 7)
  }

  const body = rows.map((row, index) => {
    const requisition = row.internal_requisition || {}
    return [
      index + 1,
      valueOrDash(requisition.code),
      formatDate(requisition.created_at),
      nameOf(requisition.department),
      nameOf(requisition.project),
      valueOrDash(INTERNAL_REQUISITION_STATUS_NAME[requisition.status]),
      nameOf(row.item),
      nameOf(row.item_unit),
      formatQuantity(row.quantity),
      valueOrDash(row.required_date),
      valueOrDash(row.remarks),
      nameOf(requisition.created_by),
    ]
  })

  doc.autoTable({
    head: [[
      { content: 'INTERNAL REQUISITION REPORT', colSpan: 12, styles: { halign: 'center', fontStyle: 'bold', textColor: '#0202f7', fontSize: 11, fillColor: [255, 255, 255] } },
    ], [
      'Sr', 'IR Code', 'IR Date', 'Department', 'Project', 'Status', 'Item', 'Unit', 'Qty', 'Required Date', 'Remarks', 'Created By Name',
    ]],
    body,
    theme: 'plain',
    startY: 40,
    margin: { top: 40, bottom: 18, left: 10, right: 10 },
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    headStyles: { fillColor: [217, 218, 219], textColor: [60, 75, 100], lineColor: '#3c4b64', lineWidth: 0.2, fontStyle: 'bold', fontSize: 8, valign: 'middle' },
    bodyStyles: { fontSize: 7.5, textColor: [0, 0, 0], lineColor: '#3c4b64', lineWidth: 0.2, cellPadding: 1.8, valign: 'middle', overflow: 'linebreak' },
    columnStyles: {
      0: { cellWidth: 9, halign: 'center' }, 1: { cellWidth: 23 }, 2: { cellWidth: 22 }, 3: { cellWidth: 28 },
      4: { cellWidth: 25 }, 5: { cellWidth: 19 }, 6: { cellWidth: 38 }, 7: { cellWidth: 17 },
      8: { cellWidth: 14, halign: 'right' }, 9: { cellWidth: 24 }, 10: { cellWidth: 33 }, 11: { cellWidth: 25 },
    },
    didParseCell: (data) => {
      if (data.section === 'head' || data.section === 'foot') data.cell.styles.fontStyle = 'bold'
    },
    didDrawPage: () => {
      header()
      footer()
    },
  })

  if (typeof doc.putTotalPages === 'function') doc.putTotalPages(totalPagesExp)
  window.open(doc.output('bloburl'), '_blank', 'noopener,noreferrer')
}

export default Pdf
